// One line into the native container's log via the `storeLog` bridge.
//
// This is the telemetry channel that does not depend on the network or on
// Sentry being reachable: docs/gpu-load-investigation.md treats container logs
// as the ground truth and Sentry as the queryable view. Silent no-op wherever
// the bridge is absent (web build, dev server, older containers without a
// storeLog handler), so callers use it unconditionally.
//
// Level scale, from the container team (2026-09-03): every level reaches the
// container's app.log as `JS[<level>]: <message>` (truncated at 2000 chars);
// WARN becomes a warning and ERROR an error in the container's own Sentry
// project, the rest stay breadcrumbs. Pick the level by what the line means
// for the machine, not by how interesting it is to us — an informational line
// at ERROR shows up as a container-side incident.
export const CONTAINER_LOG = { LOG: 0, WARN: 1, ERROR: 2, INFO: 3, DEBUG: 4 };

export const containerLog = (message, level) => {
    try {
        window.vizconContainer?.nativeCall({
            method: "storeLog",
            data: { message, level },
        });
    } catch {
        /* bridge unavailable — telemetry is best-effort */
    }
};
